import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "../../../components/atoms/button";
import Loading from "../../../components/atoms/loading";
import NavBar from "../../../components/organisms/navbar";
import rulesOpenCascavelInternationalDeJiuJitsu2025Gi from "../../../data/rules-open-cascavel-international-de-jiu-jitsu-2025-gi.json";
import useAuthenticate from "../../../hooks/useAuthenticate";
import api from "../../../services/api";
import { Content, FormContainer, PageTitle, Shake } from "../styles";
import SelectCategories from "src/components/atoms/selectCategories";
import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from "@mui/material";
import NoOptionsAlert from "src/components/atoms/no-options-alert";
interface EnrollmentData {
  id: number;
  tournamentId: number;
  valueSubscription: string;
  age: string;
  belt: string;
  category: string;
  created_at: string;
  updated_at: string;
  status: boolean;
  fighters: any | null; // Define o tipo de 'fighters' como 'null' ou 'any'
  fightersId: null | any; // Define o tipo de 'fightersId' como 'null' ou 'any'
  genre: string;
  user: {
    id: number;
    name: string;
    email: string;
    birth_date: string;
    genre: string;
    gym: string;
    mother_name: string;
    status: boolean;
  };
  weight: string;
}

const EnrollmentUpdateOpenCascavelInternationalDeJiuJitsu2025 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { getToken, account } = useAuthenticate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch } = useForm();

  const modalidade = [
    { title: "Não", option: 0 },
    { title: "Sim", option: 1 },
  ];
  const { id, slug } = useParams();
  let rules = rulesOpenCascavelInternationalDeJiuJitsu2025Gi;

  const [selectedData, setSelectedData] = useState<EnrollmentData>();
  const from = location.state?.from || '/profile/subscription';
  const mode = location.state?.mode || "";
  const isLivre = mode === "livre";
  const [ages, setAges] = useState<any>();
  const [genre, setGenre] = useState<any>();
  const [belts, setBelts] = useState<any>();
  const [disabled, setDisabled] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [noCategoriesAvailable, setNoCategoriesAvailable] = useState<boolean>(false);
  const [rawWeights, setRawWeights] = useState<any>([]);
  const [rawCategories, setRawCategories] = useState<any>([]);
  const [shakeTrigger, setShakeTrigger] = useState(0);
  const [tournament, setTournament] = useState<any>({})

  const beltsData = [
    { title: "Selecione uma opção", option: "" },
    { title: "BRANCA", option: "branca" },
    { title: "CINZA", option: "cinza" },
    { title: "AMARELA", option: "amarela" },
    { title: "LARANJA", option: "laranja" },
    { title: "VERDE", option: "verde" },
    { title: "AZUL", option: "azul" },
    { title: "ROXA", option: "roxa" },
    { title: "MARROM", option: "marrom" },
    { title: "PRETA", option: "preta" },
  ];

  const genreData = [
    { title: "Selecione uma opção", option: "" },
    { title: "MASCULINO", option: "masculino" },
    { title: "FEMININO", option: "feminino" },
  ]

  const norm = (s: any) =>
    String(s ?? "")
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, ""); // remove acentos

  // montar todos as categorias (modo livre)
  const buildAllCategories = () => {
    const categories = rules.map((r: any) => r.categoria);
    const unique = Array.from(new Set(categories));
    return [
      { title: "Selecione uma opção", option: "" },
      ...unique.map((c) => ({
        title: String(c).toUpperCase(),
        option: c,
      })),
    ];
  };

  const getUrl = (account: any | undefined, authorId: any) => {
    if (account?.roles?.includes("manager")) {
      return `/administrators/tournaments/enrollments/${id}`;
    }

    if (authorId === account?.id) {
      return `/managers/tournaments/enrollments/${id}`;
    }

    return `/tournaments/enrollments/${id}`;
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  useEffect(() => {

    if (!account) return;

    api.get(`tournaments/${slug}`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then(({ data }) => {
        setTournament(data)
      })
      ;

    if (!account) return;

    const url = getUrl(account, tournament.authorId);

    setLoading(true);
    api
      .get(url, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then(({ data }) => {
        setLoading(false);

        // Encontre o objeto com o ID correspondente e armazene-o em 'selectedData'
        setSelectedData(data);
        applyFighterLogic(data);

      })
      .catch((error) => {
        setLoading(false);
        toast.error("Não foi possível carregar os dados de inscrições.");
      });
  }, [account]);

  const applyFighterLogic = async (subscription: any) => {
    try {
      // ==== 1) Extrai e normaliza os filtros base ====
      const genreRaw = subscription?.genre;
      const ageRaw = +subscription?.age;
      const beltRaw = subscription?.belt;

      const genero = norm(genreRaw);
      const idade = Number.isFinite(ageRaw) ? ageRaw : NaN;
      const faixa = norm(beltRaw);

      setGenre(genero);
      setAges(idade);
      setBelts(beltRaw);

      if (mode === "livre") {
        // sem regras: mostra tudo
        setRawCategories(buildAllCategories());
        setNoCategoriesAvailable(false);
        return;
      }

      // ==== 2) Coleta categorias válidas ====
      const categoriasElegiveis: Array<{
        item: string;
        min: number;
        max: number;
        maxDescricao: number;
        minDescricao: number;
        descricaoCompleta: string;
      }> = [];

      for (const item of rules) {
        const generoItem = norm(item.genero);
        const faixaOk = Array.isArray(item.faixa) &&
          item.faixa.some((f: any) => norm(f?.nome) === faixa);

        if (
          item.idade?.min <= idade &&
          item.idade?.max >= idade &&
          generoItem === genero &&
          faixaOk
        ) {
          categoriasElegiveis.push({
            item: item.categoria, // mantém como está no JSON
            min: item.idade.min,
            max: item.idade.max,
            maxDescricao: item.idade.maxParaDescricao,
            minDescricao: item.idade.minParaDescricao,
            descricaoCompleta: item.idade.descricaoCompleta,
          });
        }
      }

      if (categoriasElegiveis.length === 0) {
        setNoCategoriesAvailable(true);
        setRawWeights([]);
        return;
      } else {
        setNoCategoriesAvailable(false);
      }

      const uniqueArray = [];
      const itemSet = new Set();

      for (const obj of categoriasElegiveis) {
        if (!itemSet.has(obj.item)) {
          itemSet.add(obj.item);
          uniqueArray.push(obj);
        }
      }

      const categoriasUnicas = [...new Set(uniqueArray)].map((category: any) => {
        return {
          title:
            `${category.item} - ${category.minDescricao} até ${category.maxDescricao} anos`.toUpperCase(),
          //`${category.item} - ${category.descricaoCompleta}`.toUpperCase(),
          option: category.item,
        };
      });

      setRawCategories([
        {
          title: "Selecione uma opção",
          option: "",
        },
        ...categoriasUnicas
      ]);

      // ==== 3) Coleta pesos COM base na categoria local (sem depender do estado) ====
      const pesosElegiveis: Array<{ peso: string; massa: string }> = [];

      for (const item of rules) {
        const generoItem = norm(item.genero);
        const faixaOk = Array.isArray(item.faixa) &&
          item.faixa.some((f: any) => norm(f?.nome) === faixa);

        if (
          item.idade?.min <= idade &&
          item.idade?.max >= idade &&
          generoItem === genero &&
          watch('category') &&
          faixaOk
        ) {
          pesosElegiveis.push({
            peso: item.peso.descricao,
            massa: item.peso.max,
          });
        }
      }

      const pesosUnicos = pesosElegiveis.map(pes => {
        return {
          title: `${pes.peso} - ${pes.massa}`.toUpperCase(),
          option: pes.peso
        }
      })


      setRawWeights([
        {
          title: "Selecione uma opção",
          option: "",
        },
        ...pesosUnicos
      ]);

    } catch (err) {
      console.error("applyFighterLogic error:", err);
      setNoCategoriesAvailable(true);
      setRawWeights([]);
    }
  };

  const handleChangeWeights = (e: any) => {
    setValue("weight", "");
    // ==== 3) Coleta pesos COM base na categoria local (sem depender do estado) ====
    const pesosElegiveis: Array<{ peso: string; massa: string }> = [];
    if (mode === 'livre') {
      for (const item of rules) {
        if (
          item.genero === watch('genre').toLowerCase() &&
          item.categoria === e.target.value
        ) {
          pesosElegiveis.push({
            peso: item.peso.descricao,
            massa: item.peso.max,
          });
        }
      }

      const unique = Array.from(new Set(pesosElegiveis));

      const pesosUnicos = unique.map(pes => {
        return {
          title: `${pes.peso} - ${pes.massa}`.toUpperCase(),
          option: pes.peso
        }
      })

      setRawWeights([
        {
          title: "Selecione uma opção",
          option: "",
        },
        ...pesosUnicos
      ]);

    } else {
      for (const item of rules) {
        const generoItem = norm(item.genero);

        if (
          item.idade.max >= +ages &&
          item.idade.min <= +ages &&
          generoItem === genre &&
          item.categoria === e.target.value
        ) {
          pesosElegiveis.push({
            peso: item.peso.descricao,
            massa: item.peso.max
          })
        }

      }

      const unique = Array.from(new Set(pesosElegiveis));

      const pesosUnicos = unique.map(pes => {
        return {
          title: `${pes.peso} - ${pes.massa}`.toUpperCase(),
          option: pes.peso
        }
      })

      setRawWeights([
        {
          title: "Selecione uma opção",
          option: "",
        },
        ...pesosUnicos
      ]);
    }

  };

  const onSubmit = (data: any) => {
    setDisabled(true);
    setLoading(true);

    // Verificando se `modalidade` é uma string ou número e ajustando a comparação
    const category =
      +data.modalidade === 1
        ? "pcd - " + data.category
        : +data.modalidade === 0
          ? data.category
          : "";

    api
      .patch(
        `/tournaments/enrollments/${id}`,
        {
          //...data,
          slug: slug,
          age: String(ages),
          belt: data.belt,
          genre: data.genre,
          weight: data.weight,
          category: category,
          fightersId: selectedData?.fightersId!,
        },
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        }
      )
      .then(() => {
        toast.success("A sua atualização da inscrição foi realizada com sucesso!");

        setTimeout(() => {
          navigate(from);
        }, 2000);
      })
      .catch((error) => {
        setDisabled(false);
        setLoading(false);
        toast.error(error?.data?.message || "Não foi possível gerar a sua atualização da inscrição!");
      });
  };

  useEffect(() => {
    register("weight", {
      required: "Selecione seu peso.",
    });
    register("category", {
      required: "Selecione uma categoria.",
    });
    register("modalidade", {
      required: "Selecione uma modalidade.",
    });
  }, [register]);

  if (loading)
    return <Loading text="Aguarde, estamos processando a sua pré-inscrição." />;

  return (
    <div>
      <NavBar />
      <Content>
        <FormContainer onSubmit={handleSubmit(onSubmit, () => {
          // Reinicia a animação se houver erro
          setShakeTrigger(prev => prev + 1);
        })}>

          <PageTitle>
            Atualização de Inscrição Nº {id}
            {/* <h2 style={{ color: "red" }}>{" "} OBS:  CORREÇÃO ENCERRADA</h2> */}
          </PageTitle>
          {/* <PageDescription>Atualização de inscrição</PageDescription> */}

          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>

            {/* Gênero */}
            {isLivre ? (
              <SelectCategories
                label="Gênero:"
                name="genre"
                register={register}
                required
                hasError={!!errors.genre}
                error={typeof errors.genre?.message === "string" ? errors.genre.message : "Este campo é obrigatório"}
                options={genreData}
              />
            ) : (
              <Typography sx={{ fontWeight: 500, fontSize: '1.2rem' }}>
                Gênero: {genre?.toUpperCase?.() || 'N/A'}
              </Typography>
            )}

            {/* Faixa */}
            {isLivre ? (
              <SelectCategories
                label="Faixa:"
                name="belt"
                register={register}
                required
                hasError={!!errors.belt}
                error={typeof errors.belt?.message === "string" ? errors.belt.message : "Este campo é obrigatório"}
                options={beltsData}
              />
            ) : (
              <Typography sx={{ fontWeight: 500, fontSize: '1.2rem' }}>
                Faixa: {belts?.toUpperCase?.() || 'N/A'}
              </Typography>
            )}

            {!isLivre && (
              <Typography sx={{ fontWeight: 500, fontSize: '1.2rem' }}>
                Idade de luta: {ages + ' anos' || 'N/A'}
              </Typography>
            )}

            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <NoOptionsAlert
                show={noCategoriesAvailable}
                type="categories"
                fighterData={{
                  name: selectedData?.fighters
                    ? selectedData?.fighters?.name
                    : selectedData?.user?.name,
                  age: isLivre ? (watch("ageFight") ?? "") : (ages || ""),
                  gender: isLivre ? (watch("genre") ?? "") : (genre || ""),
                  belt: isLivre ? (watch("belt") ?? "") : (belts || ""),
                }}
              />
            </Box>
          </Box>

          {!noCategoriesAvailable && (
            <>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box
                  sx={{
                    animation: !!errors.category ? `${Shake} 0.3s ease-in-out` : "none",
                  }}
                >
                  <SelectCategories
                    label="Categoria:"
                    name="category"
                    register={register}
                    required
                    hasError={!!errors.category}
                    error="Este campo é obrigatório"
                    options={rawCategories}
                    onChange={handleChangeWeights}
                  />
                </Box>

                <Box
                  sx={{
                    animation: !!errors.weight ? `${Shake} 0.3s ease-in-out` : "none",
                  }}
                >
                  <SelectCategories
                    label="Peso:"
                    name="weight"
                    register={register}
                    required
                    hasError={!!errors.weight}
                    error="Este campo é obrigatório"
                    options={rawWeights}
                  />
                </Box>

                <FormControl
                  component="fieldset"
                  error={!!errors.modalidade}
                  sx={{
                    animation: !!errors.modalidade ? `${Shake} 0.3s ease-in-out` : "none",
                  }}
                >
                  <FormLabel component="legend" style={{ color: "#33303E" }}>
                    Pessoa com deficiência - PcD?
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-label="PcD"
                    value={watch("modalidade")}
                    onChange={(e) =>
                      setValue("modalidade", e.target.value, { shouldValidate: true })
                    }
                  >
                    {modalidade.map((m) => (
                      <FormControlLabel
                        key={m.option}
                        value={String(m.option)}
                        control={<Radio color="error" />}
                        label={m.title}
                      />
                    ))}
                  </RadioGroup>
                  <Typography variant="caption" color="error" sx={{ ml: 1 }}>
                    {typeof errors.modalidade?.message === "string"
                      ? errors.modalidade.message
                      : ""}
                  </Typography>
                </FormControl>
              </Box>

              <Button type="submit" label="Editar inscrição" disabled={disabled} /></>
          )}
        </FormContainer>
      </Content>
    </div>
  );
};

export default EnrollmentUpdateOpenCascavelInternationalDeJiuJitsu2025;
